import styled from 'styled-components';
import PropTypes from 'prop-types';

import PassDesktopIcon from '../PassDesktopIcon';

const Container = styled.div`
  position: absolute;
  top: 20%;
  width: 50%;
`;

const PassBackground = () => {
  return (
    <Container>
      <PassDesktopIcon />
    </Container>
  );
};

PassBackground.propTypes = {
  realm: PropTypes.string,
};

export default PassBackground;
